import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { BillInfo } from '@picsio/icons';

import localization from '../../../shared/strings';
import RelativeTime from '../../RelativeTime';
import Tooltip from '../../Tooltip/Tooltip';
import styles from './ProductLayerMetaRow.module.scss';

const l10n = localization.PRODUCT_INFO;

const ProductLayerMetaRow = ({
  updatedAt,
  timeKind,
  statusLabel,
  statusTooltip,
  isMasterStatus,
  statusControl,
  children,
}) => {
  const renderTime = useCallback((time) => {
    const label = timeKind === 'published'
      ? l10n.lastPublished(time)
      : l10n.lastUpdated(time);

    return (
      <span className={styles.timestamp}>
        {label}
      </span>
    );
  }, [timeKind]);

  return (
    <>
      <If condition={Boolean(updatedAt)}>
        <div className={styles.timestampSection} data-qa="product-layer-timestamp">
          <RelativeTime value={updatedAt}>
            {renderTime}
          </RelativeTime>
        </div>
      </If>
      <div className={styles.coreWithStatus}>
        <span className={styles.statusCluster} data-qa="product-layer-status">
          <span
            className={cn(styles.statusLabel, {
              [styles.statusLabelMaster]: isMasterStatus,
            })}
          >
            {statusLabel}
          </span>
          <If condition={Boolean(statusTooltip)}>
            <Tooltip content={statusTooltip} placement="top">
              <Icon className={styles.statusIcon}>
                <BillInfo />
              </Icon>
            </Tooltip>
          </If>
          {statusControl}
        </span>
        {children}
      </div>
    </>
  );
};

ProductLayerMetaRow.propTypes = {
  updatedAt: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.instanceOf(Date),
  ]),
  timeKind: PropTypes.oneOf(['updated', 'published']),
  statusLabel: PropTypes.string.isRequired,
  statusTooltip: PropTypes.string,
  isMasterStatus: PropTypes.bool,
  statusControl: PropTypes.node.isRequired,
  children: PropTypes.node,
};

ProductLayerMetaRow.defaultProps = {
  updatedAt: null,
  timeKind: 'updated',
  statusTooltip: null,
  isMasterStatus: false,
  children: null,
};

export default ProductLayerMetaRow;
